export * from './balance-of-contract.component';
export * from './balance-of-contract-document-capture.component';
export * from './balance-of-contract.module';